import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _AbstractAccount, _AccountINFORPO, _single } from "../../../../../core/services/dataBean/EntityCatalog";

import { SelectCreditRoleGroup } from "../../../../erp/CreditRoleGroup/SelectCreditRoleGroup";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const CC011 = ({ configProcedure }: Props) => {

    // const { instance, lista, setLista, bean, setBean } = useDataBean(_AbstractAccount);
    const [props, setProps] = useState<any>({});
    const [bean, setBean] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(`Se Asigna procedimiento al Analista: ${bean.NameUser}`)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ IDAnalist: bean.IDReferencer })
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean)
        }

    }


    return (
        <div className="row">
            <div className="col-md-12">
                <SelectCreditRoleGroup label="Analista" idSelector={bean.IDReferencer} onChange={(e) => { setBean({ ...bean, IDReferencer: e?.IDAccount, NameUser: e.AccountName, Role: e.RoleName }); console.log(e) }} returnType="Object" filterUser="IsAnalist" />
            </div>
            <div className="col-md-12 mt-4">
                <BasicButton eventClick={onExportMap} icon="ri-send-plane-line" children={`Seleccionar`} />
            </div>
        </div>
    );
};